import { calcBackgroundVideoSize } from '../modules/background-videos-size';
import { deviceIsMobile } from '../utils/size-check';
import Player from '@vimeo/player';

const youtubeVideoPlayers = [];
const vimeoVideoPlayers = [];
const $videoWrapper = $('.js-autoplay-videos');

/**
 * Add event listener for scroll autoplay videos
 * @param {Object} videoObject - Youtube/Vimeo API object
 * @param {String} videoType - youtube/vimeo
 */
 const checkScrollPosition =  (videoObject, videoType = "youtube") => {
  if ($videoWrapper.length) {
    $(window).on('scroll resize', () => {
      // Check scroll position
      const videosWrapperPosition = $videoWrapper[0].offsetTop;
      const scrollPosition = $(document).scrollTop() + $(window).outerHeight();
      if ( !(scrollPosition > videosWrapperPosition && videosWrapperPosition !== 0) ) {
        return;
      }

      if (!deviceIsMobile()) {
        // Autoplay video if not in slider
        if (videoType == 'youtube') {

          // Play youtube video
          videoObject.playVideo()
          return;
        }
        // Play vimeo video
        videoObject['play']();
        return;
      }

      // Play video depending on active slide
      playFromActiveSlide();
    })
  }
}

/**
 * Play video depending on active slide
 * @return {JQuery Element}
 */
export const playFromActiveSlide = () => {
  let activeVideoElement = null;
  youtubeVideoPlayers.map(videoPlayer => {
    // Youtube video object element
    const target = videoPlayer.i;
    $('.js-video-autoplay').map((index, videoWrapper) => {
      const $video = $(videoWrapper)
      if ($video[0] === target && $video.parents('.slick-active').length) {
        videoPlayer.playVideo();
        activeVideoElement = $video;
      } else if ($video[0] === target) {
        videoPlayer.pauseVideo();
      }
    })
  })

  vimeoVideoPlayers.map(videoPlayer => {
    // Vimeo video object element
    const target = videoPlayer.element;
    $('.js-video-autoplay').map((index, videoWrapper) => {
      const $video = $(videoWrapper).find(':first-child')
      if ($video[0] === target && $video.parents('.slick-active').length) {
        videoPlayer['play']();
        activeVideoElement = $video;
      } else if ($video[0] === target) {
        videoPlayer['pause']();
      }
    })
  })

  return activeVideoElement;
}

/**
 * Load autoplay videos
 */
export const loadAutoplayVideos = () => {
  $('.js-video-autoplay').each(function () {
    const $video = $(this);
    const videoUrl = $video.data('video');

    if (videoUrl.includes('youtube.com')) {
      const videoId = videoUrl.split('?v=').pop().split('&')[0];

      let player = new YT.Player(this, {
        videoId: videoId,
        playerVars: {
          autoplay: false, // Auto-play the video on load
          playsinline: 1,
          loop: 1, // Run the video in a loop
          controls: 0, // Show pause/play buttons in player
          disablekb: 1,
          showinfo: 0, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          rel: 0, // Hide related videos
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0, // Hide video controls when playing
        },
        events: {
          onReady: function (event) {
            event.target.mute();
            checkScrollPosition(event.target)
          },
          onStateChange: function (event) {
            // video ended
            if (event.data == 0) {
              event.target.playVideo();
            }
          },
        },
      });

      if (!$video.parents('.slick-cloned').length && deviceIsMobile()) {
        youtubeVideoPlayers.push(player);
      } else if (!deviceIsMobile()) {
        youtubeVideoPlayers.push(player);
      }
    } else if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
      const options = {
        id: videoId,
        title: false,
        muted: true,
        loop: true,
        controls: false,
        autopause: false
      };

      // Create Vimeo Player
      const player = new Player($video, options);
      player.ready().then(function () {
        // Autoplay
        checkScrollPosition(player, 'vimeo')
      });

      if (!$video.parents('.slick-cloned').length) {
        vimeoVideoPlayers.push(player)
      }
    }
  });
}
